import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const modalActionsStyles = css`
  @media (max-width: ${breakpoints.xsmall.max}px) {
    flex-direction: column;

    button {
      width: 100%;
    }

    button:not(:last-of-type) {
      margin-right: 0;
      margin-bottom: ${theme.spacing(2)};
    }

    button:last-of-type {
      margin-left: 0;
    }
  }
`;

export const modalBodyStyles = css`
  text-align: center;
`;
